import { useCurrentUser } from '@features/users';
import { useFeatures } from '@utils/hooks';

/**
 * Returns true when Cross Channel Analysis is enabled for the current user:
 * - Feature flag crossChannelAnalysis is on, and
 * - User has internal_user or admin role (internal-only at launch).
 */
export const useCrossChannelAnalysisEnabled = (): boolean => {
  const features = useFeatures();
  const { role } = useCurrentUser();

  return (
    features.crossChannelAnalysis === true &&
    (role === 'internal_user' || role === 'admin')
  );
};
